import { GameIntroBaseScene } from "src/games/shared/scenes/GameIntroBase";
import { Games } from "src/constants/Games";
import { HowToPlayScene } from "./IntroductionScene";

export class GameIntroScene extends GameIntroBaseScene {
    constructor() {
        super();
        this.gameRef = Games.Starball;
        this.howToPlayScene = HowToPlayScene;
        this.introTextKeys = [
            "Starball.Phaser.IntroductionScene.1",
            "Starball.Phaser.IntroductionScene.2",
        ];
    }
}



// WEBPACK FOOTER //
// ./src/games/StarballGame/scenes/GameIntro.ts